import { render, staticRenderFns } from "./AdvertenciaCuentaCorriente.vue?vue&type=template&id=37816237&"
import script from "./AdvertenciaCuentaCorriente.vue?vue&type=script&lang=js&"
export * from "./AdvertenciaCuentaCorriente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports